import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EquipmentRepairs from "./EquipmentRepairs";
import WorkCompleted from "./WorkCompleted";
import OutdoorSports from "./OutdoorSports";
import WorkInAction from "./WorkInAction";
import Playgrounds from "./Playgrounds";

const GalleryTab = () => {
  const { t } = useTranslation("gallery");
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabs = [
    {
      label: t("tabPlaygrounds"),
      component: <Playgrounds />,
    },
    {
      label: t("tabOutdoorSports"),
      component: <OutdoorSports />,
    },
    {
      label: t("tabEquipmentRepairs"),
      component: <EquipmentRepairs />,
    },
    {
      label: t("tabWorkCompleted"),
      component: <WorkCompleted />,
    },

    {
      label: t("tabVideos"),
      component: <WorkInAction />,
    },
  ];

  return (
    <section className="w-full px-[5%]">
      <div
        className="pt-12 pb-16 sm:pb-20 maxContainer sm:pt-16"
        id="gallery-tab"
      >
        {/* Tab Navigation */}
        <div className="flex justify-center w-full pb-5">
          <Tabs
            value={activeTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Gallery Tabs"
            TabIndicatorProps={{ style: { backgroundColor: "#F7AF0C" } }}
            className="bg-white shadow-sm"
          >
            {tabs.map((tab, idx) => (
              <Tab
                key={idx}
                label={tab.label}
                sx={{
                  fontWeight: activeTab === idx ? "600" : "500",
                  fontSize: "12px",
                  "&.Mui-selected": {
                    color: "#F7AF0C",
                  },
                }}
                className={`capitalize px-4 py-2 transition-all duration-300 
                ${
                  activeTab === idx
                    ? "text-black"
                    : "text-greyText font-medium hover:text-black"
                }`}
              />
            ))}
          </Tabs>
        </div>

        <div>{tabs[activeTab].component}</div>
      </div>
    </section>
  );
};

export default GalleryTab;
